import {BaseModel} from "@shared/models/base.model";
import {DocumentTemplateTypeEnum, DocumentTemplateTypeType as BaseType} from "@generated/graphql";

export class DocumentTemplateType extends BaseModel implements BaseType {
  id: string;
  _model: string;
  frequencyOfGeneration: string;
  name: DocumentTemplateTypeEnum;

  getModelName(): string {
    return DocumentTemplateType.name;
  }
}
